<!--
 * @Author: your name
 * @Date: 2022-03-15 17:11:53
 * @LastEditTime: 2022-03-16 14:26:44
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\components\do\DSelect.vue
-->

<template>
  <a-select
    :placeholder="placeholder"
    style="width: 100%"
    :disabled="disabled"
    :value="selectedValue"
    @change="onChange"
  >
    <a-select-option v-for="itemO in data" :key="itemO.id" :value="itemO.id">{{ itemO.name }}</a-select-option>
  </a-select>
  <!-- <a-tree-select
    allowClear
    labelInValue
    :getPopupContainer="(node) => node.parentNode"
    style="width: 100%"
    :disabled="disabled"
    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
    :placeholder="placeholder"
    :loadData="asyncLoadTreeData"
    :value="treeValue"
    :treeData="treeData"
    :multiple="multiple"
    @change="onChange"
    @search="onSearch"
  >
  </a-tree-select> -->
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'DSelect',
  props: {
    value: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
      required: false,
    },
    pidValue: {
      type: String,
      default: '',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      selectedValue: null,
      data: [],
      url: `${window._CONFIG['doBaseUrl']}/doMistServer//resource/getResourcePropsByPid`,
      text: '',
    }
  },
  watch: {
    value() {
      this.loadItemByCode()
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      let param = {
        resourceId: this.pidValue,
        pageNumber: 1,
        pageSize: 50,
      }
      getAction(this.url, param).then((res) => {
        if (res.success && res.result) {
          this.data = res.result.map((r) => ({
            id: r.id,
            name: r.name,
          }))
          this.selectedValue = this.value
        } else {
          console.log('数根节点查询结果-else', res)
        }
      })
    },
    loadItemByCode() {
      console.log(this.value)
      if (!this.value || this.value == '0') {
        this.selectedValue = null
      } else {
        this.selectedValue = this.value
      }
    },
    onChange(value) {
      if (!value) {
        this.$emit('change', '')
        this.selectedValue = null
      } else if (value instanceof Array) {
        // this.$emit('change', value.map((item) => item.value).join(','))
        // this.selectedValue = value
      } else {
        this.$emit('change', value)
        this.selectedValue = value
      }
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
}
</script>